import { render, staticRenderFns } from "./ExamMasterUser.vue?vue&type=template&id=3636d7b4"
import script from "./ExamMasterUser.vue?vue&type=script&lang=js"
export * from "./ExamMasterUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports